export default "__VITE_ASSET__3aed3481__"